import React, {PureComponent} from 'react';
import {SubmitButton} from './components/SubmitButton';

export class ContactForm extends PureComponent {

    state = {
        success: false,
        failure: false,
        pending: false
    };

    submit = (event) => {
        event.preventDefault();

        const {target} = event;
        const formData = new FormData(target);

        formData.append('contact-subject', 'Asbestkrachten: nieuwe aanmelding');

        const urlSearchParams = new URLSearchParams(formData);
        const options = {
            method: 'post',
            body: urlSearchParams,
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            })
        };

        this.setState({
            success: false,
            failure: false,
            pending: true
        });

        fetch('/PHPMailer/asbestkrachten_contact_form.php', options)
            .then((response) => {
                if (response.ok) {
                    this.setState({
                        success: true,
                        failure: false,
                        pending: false
                    });

                    target.reset();
                } else {
                    this.setState({
                        failure: true,
                        success: false,
                        pending: false
                    });
                }
            })
            .catch((error) => {
                console.error(error);

                this.setState({
                    failure: true,
                    success: false,
                    pending: false
                });
            });

        return false;
    };

    render = () => {
        const {style, buttonMessage = 'Verzend'} = this.props;
        const {success, failure, pending} = this.state;

        const _buttonMessage = success
            ? 'Uw bericht is verstuurd!'
            : pending
                ? 'Uw bericht is onderweg...'
                : failure
                    ? 'Bericht is niet verzonden door een fout!'
                    : buttonMessage;

        const buttonStyle = {
            backgroundColor: failure ? 'red' : undefined
        };

        return (
            <form id="contact-form" onSubmitCapture={this.submit} style={style}>
                {this.props.children}
                <SubmitButton value={_buttonMessage} style={buttonStyle}/>
            </form>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/ContactForm.jsx